import { ActionTypes } from "@/App/constants/actionTypes";
import { PlanBenefitTypes, GeneralTypes } from "@/types";

type SearchPlanBenefitListAction = {
  type: typeof ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST;
  payload: GeneralTypes.QueryOptions;
  formName: string;
};

export const searchPlanBenefitList = (data: { data: GeneralTypes.QueryOptions; formName: string }): SearchPlanBenefitListAction => {
  return {
    type: ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST,
    payload: data.data,
    formName: data.formName,
  };
};

type SearchPlanBenefitListResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST_RESULTS;
  payload: { results: Array<PlanBenefitTypes.PlanBenefit>; result_count: string };
};

export const searchPlanBenefitListResults = (data: {
  results: Array<PlanBenefitTypes.PlanBenefit>;
  result_count: string;
}): SearchPlanBenefitListResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST_RESULTS,
    payload: data,
  };
};

export type PlanBenefitSearchActions = SearchPlanBenefitListAction | SearchPlanBenefitListResultsAction;
